import React, { createContext, useState, useContext, useEffect } from 'react';

const ClientAuthContext = createContext();

export const useClientAuth = () => {
  const context = useContext(ClientAuthContext);
  if (!context) {
    throw new Error('useClientAuth must be used within a ClientAuthProvider');
  }
  return context;
};

export const ClientAuthProvider = ({ children }) => {
  const [portalClient, setPortalClient] = useState(null);
  const [isClientAuthenticated, setIsClientAuthenticated] = useState(false);
  const [loadingClient, setLoadingClient] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('client_token');
    const userData = localStorage.getItem('client_user');

    if (token && userData) {
      try {
        const parsed = JSON.parse(userData);
        setPortalClient(parsed);
        setIsClientAuthenticated(true);
      } catch {
        localStorage.removeItem('client_token');
        localStorage.removeItem('client_refreshToken');
        localStorage.removeItem('client_user');
      }
    }
    setLoadingClient(false);
  }, []);

  const clientLogin = (accessToken, refreshToken, userData) => {
    localStorage.setItem('client_token', accessToken);
    localStorage.setItem('client_refreshToken', refreshToken);
    localStorage.setItem('client_user', JSON.stringify(userData));
    setPortalClient(userData);
    setIsClientAuthenticated(true);
  };

  const clientLogout = () => {
    localStorage.removeItem('client_token');
    localStorage.removeItem('client_refreshToken');
    localStorage.removeItem('client_user');
    setPortalClient(null);
    setIsClientAuthenticated(false);
  };

  const updatePortalClient = (updatedUser) => {
    setPortalClient(updatedUser);
    localStorage.setItem('client_user', JSON.stringify(updatedUser));
  };

  return (
    <ClientAuthContext.Provider value={{
      portalClient,
      isClientAuthenticated,
      loadingClient,
      clientLogin,
      clientLogout,
      updatePortalClient,
    }}>
      {children}
    </ClientAuthContext.Provider>
  );
};
